import { useState } from 'react';
import { FolderKanban, ClipboardList, CalendarDays, LayoutGrid, Settings, Wrench } from 'lucide-react';
import Expedients from './taller/Expedients';
import WorkOrdersList from './taller/WorkOrdersList';
import Planificacio from './taller/Planificacio';
import Infraestructura from './taller/Infraestructura';
import Manteniments from './taller/Manteniments';

const tabs = [
  { id: 'expedients', label: 'Expedients de Taller', icon: FolderKanban, color: 'blue' },
  { id: 'ots', label: "Llista d'OT's", icon: ClipboardList, color: 'purple' },
  { id: 'planificacio', label: 'Planificació', icon: LayoutGrid, color: 'amber' },
  { id: 'calendari', label: 'Calendari Taller', icon: CalendarDays, color: 'green' },
  { id: 'infraestructura', label: 'Infraestructura', icon: Settings, color: 'teal' },
  { id: 'manteniments', label: 'Manteniments', icon: Wrench, color: 'red' },
];

const COLOR: Record<string, { border: string; bg: string; icon: string; iconBg: string }> = {
  blue:   { border: 'border-blue-500',   bg: 'bg-blue-50/50',   icon: 'text-blue-500',   iconBg: 'bg-blue-500/10' },
  purple: { border: 'border-purple-500', bg: 'bg-purple-50/50', icon: 'text-purple-500', iconBg: 'bg-purple-500/10' },
  amber:  { border: 'border-amber-500',  bg: 'bg-amber-50/50',  icon: 'text-amber-500',  iconBg: 'bg-amber-500/10' },
  green:  { border: 'border-green-500',  bg: 'bg-green-50/50',  icon: 'text-green-500',  iconBg: 'bg-green-500/10' },
  teal:   { border: 'border-teal-500',   bg: 'bg-teal-50/50',   icon: 'text-teal-500',   iconBg: 'bg-teal-500/10' },
  red:    { border: 'border-red-500',    bg: 'bg-red-50/50',    icon: 'text-red-500',    iconBg: 'bg-red-500/10' },
};

export default function Taller() {
  const [activeTab, setActiveTab] = useState('expedients');

  const renderContent = () => {
    switch (activeTab) {
      case 'expedients':
        return <Expedients />;
      case 'ots':
        return <WorkOrdersList />;
      case 'planificacio':
        return <Planificacio />;
      case 'calendari':
        return (
          <div className="p-8 text-center text-slate-500">
            <CalendarDays className="w-16 h-16 mx-auto mb-4 opacity-50" />
            <p className="text-sm font-medium mb-2">Calendari de Taller</p>
            <p className="text-sm">Vista de planificació d&apos;expedients i OT&apos;s per dia/setmana/mes - En desenvolupament</p>
          </div>
        );
      case 'infraestructura':
        return <Infraestructura />;
      case 'manteniments':
        return <Manteniments />;
      default:
        return <Expedients />;
    }
  };

  return (
    <div className="space-y-6">
      <div className="sticky top-0 z-10 bg-white -mt-6 pt-6 pb-4 space-y-6">
        {/* Capcalera */}
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold tracking-tight">Taller</h1>
            <p className="text-muted-foreground">
              Gestió d&apos;ordres de treball i costos
            </p>
          </div>
          {/* Slot per a accions especifiques de la pestanya activa (p.ex.
              Imprimir/Excel d'Expedients), injectades via portal. */}
          <div id="taller-header-actions" className="flex items-center gap-2" />
        </div>

        {/* Tabs */}
        <div className="grid grid-cols-3 md:grid-cols-6 gap-3">
          {tabs.map((tab) => {
            const Icon = tab.icon;
            const c = COLOR[tab.color];
            const active = activeTab === tab.id;
            return (
              <button
                key={tab.id}
                type="button"
                onClick={() => setActiveTab(tab.id)}
                className={`flex items-center gap-3 px-4 py-2.5 rounded-xl border transition-all ${
                  active ? `${c.border} ${c.bg}` : 'border-border bg-white hover:shadow-sm'
                }`}
              >
                <div className={`p-1.5 rounded-lg shrink-0 ${c.iconBg}`}>
                  <Icon className={`h-4 w-4 ${c.icon}`} />
                </div>
                <span className="text-xs font-semibold">{tab.label}</span>
              </button>
            );
          })}
        </div>
      </div>

      {/* Content */}
      <div className="bg-white rounded-lg border border-border">
        {renderContent()}
      </div>
    </div>
  );
}
